// Definición de defaults

export const defaultTipoRecurso: TipoRecursoProps = {
    idTipoRecurso:      0,
    descripcion:        '',
    activo:             false,
};

// Creación de interfaces

export interface TipoRecursoProps   {
    idTipoRecurso:      number;
    descripcion:        string;
    activo:             boolean;
}